import { api } from "../utils/api";
import { User } from "../types/auth";

export const login = async (
  username: string,
  password: string
): Promise<User> => {
  const response = await api.post<{ data: User }>("/api/login", {
    username,
    password,
  });
  return response.data;
};

export const logout = async (): Promise<void> => {
  await api.get("/api/logout");
};

export const getCurrentUser = async (): Promise<User | null> => {
  try {
    const response = await api.get<{ data: User }>("/api/me");
    return response.data;
  } catch (error) {
    return null;
  }
};
